import axios from './http'
import base from './base'

/**
 * post方法，对应post请求
 * @desc注册请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

// 获取员工信息
export function getCurrentEmployeeSimpleInfo(data) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/employee/getCurrentEmployeeSimpleInfo`,
    method: 'get',
    headers: {
      notLoading: true,
    },
    data,
  })
}

// 获取用户租户列表
export function getTenantList(data) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/tenant/getCurrentTenantList`,
    headers: {
      notLoading: true,
    },
    method: 'get',
    data,
  })
}

// 选中公司接口
export function selectTenant(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/tenant/appointTenant`,
    method: 'get',
    headers: {
      notLoading: true,
    },
    params,
  })
}

// 获取需要鉴权的菜单树
export function getCurrentMenuTree(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/resource/getAuthMenuTree`,
    method: 'get',
    params,
  })
}

// 获取需要鉴权的菜单树
export function getAllMenuTree(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/resource/getCurrentMenuTree`,
    method: 'get',
    headers: {
      notLoading: true,
    },
    params,
  })
}

// 获取用户信息接口
export function getUserInfo(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/userInfo/getUserInfo`,
    method: 'get',
    headers: {
      notLoading: true,
    },
    params,
  })
}

// 修改用户姓名
export function updateUserName(data) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/userInfo/updateUserName`,
    method: 'post',
    data: data,
  })
}

// 修改用户手机号
export function updateUserPhone(data) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/userInfo/updateUserMobile`,
    method: 'post',
    data: data,
  })
}

// 获取修改手机号验证码
export function getUpdateUserPhoneCode(data) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/captcha/getSmsUpdateMobileCaptcha`,
    method: 'post',
    data: data,
  })
}
// 获取当前租户信息

export function getCurrentTenant(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/tenant/getCurrentTenant`,
    method: 'get',
    headers: {
      notLoading: true,
    },
    params,
  })
}

// 完善租户信息
export function updateTenant(data) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/tenant/completeTenantInfo`,
    method: 'post',
    data: data,
  })
}

// 获取行业树
export function getIndustryTree(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/industry/getIndustryTree`,
    method: 'get',
    headers: {
      notLoading: true,
    },
    params,
  })
}

// 修改用户头像
export function updateUserAvatar(data) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/userInfo/updateUserHeadPortrait`,
    method: 'post',
    data: data,
  })
}

// 修改密码
export function updatePassword(data) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/userAuth/updatePassword`,
    method: 'post',
    data: data,
  })
}

// 创建租户
export function createTenant(data) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/tenant/createTenant`,
    method: 'post',
    data: data,
  })
}

//获取当前已禁用的租户列表
export function getDisableTenantList(data) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/tenant/getCurrentDisableTenantList`,
    method: 'get',
    data,
  })
}

// ocr文字识别
export function ocrText(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/ocr/bizLicenseOCR`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    params,
  })
}

//是否展示邀请码按钮
export function isShowInviteCode(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/tenant/isShowBinding`,
    method: 'post',
    data: params,
  })
}

//保存邀请码
export function saveInviteCode(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/tenant/saveInviteCode`,
    method: 'post',
    data: params,
  })
}
// 获取结算账户
export function getSettleAccount(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/settleAccount/getSettleAccount`,
    method: 'post',
    data: params,
  })
}
// 个人结算账户信息
export function addSettleAccount(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/settleAccount/addSettleAccount`,
    method: 'post',
    data: params,
  })
}

// 解绑微信
export function unBingUserWechat(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/userInfo/unBingUserWechat`,
    method: 'post',
    data: params,
  })
}

// 个人设置页面微信绑定手机号
export function wcBingMobile(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/userInfo/wcBingMobile`,
    method: 'post',
    data: params,
  })
}
// 获取租户是否开通自研销项
export function getTenantIsOpenTax(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/tenant/getTenantIsOpenTax`,
    method: 'post',
    data: params,
  })
}

//获取员工所属企业列表
export function getTenantListByUserId(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/employee/getTenantListByUserId`,
    method: 'get',
    params,
  })
}

//自主退出企业
export function quitCompany(data) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/employee/quitCompany`,
    method: 'post',
    data:data
  })
}
